
import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Messages from './pages/Messages';
import Credits from './pages/Credits';
import Admin from './pages/Admin';
import Inbox from './pages/Inbox';
import ReminderLogs from './pages/ReminderLogs';

import Layout from './components/Layout';

const PrivateRoute = ({ children }) => {
  return localStorage.getItem('token')
    ? children
    : <Navigate to="/login" />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login Page */}
        <Route
          path="/login"
          element={<Login />}
        />

        {/* Protected CRM Routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          {/* Dashboard */}
          <Route
            index
            element={<Dashboard />}
          />

          {/* Messages */}
          <Route
            path="messages"
            element={<Messages />}
          />

          {/* Reminder Logs */}
          <Route
            path="reminder-logs"
            element={<ReminderLogs />}
          />

          {/* Inbox */}
          <Route
            path="inbox"
            element={<Inbox />}
          />

          {/* Credits */}
          <Route
            path="credits"
            element={<Credits />}
          />

          {/* Admin */}
          <Route
            path="admin"
            element={<Admin />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
